<template lang="pug">
    include RegisterOk.pug
</template>

<script>

export default {
  name: 'RegisterOk',
  components: '',
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "RegisterOk";
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterOk.vue